import { Stack } from "@mui/material";
import { PatientProfile, Task } from "src/api/types";
import PrescriptionRequest from "src/components/PrescriptionRequest";
import PrescriptionProvider from "src/context/PrescriptionProvider";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => Promise<void>;
  patient: PatientProfile;
}

const PrescriptionReviewTask = ({ task, onSuccess, patient }: Props) => {
  return (
    <PrescriptionProvider prescriptionId={task.resource_id}>
      <Stack gap={2}>
        <TaskWrapper task={task}>
          <PrescriptionRequest
            onSuccess={onSuccess}
            patientRegion={patient.profile.region}
          />
        </TaskWrapper>
      </Stack>
    </PrescriptionProvider>
  );
};

export default PrescriptionReviewTask;
